export default "__VITE_ASSET__Dhzqhep3__"